// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const LightBulbIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "LightBulb/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 3a1 1 0 1 0-2 0v1a1 1 0 0 0 2 0V3ZM15.657 5.757a1 1 0 1 0-1.414-1.414l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707ZM18 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1ZM5.05 6.464A1 1 0 1 0 6.465 5.05l-.708-.707a1 1 0 0 0-1.414 1.414l.707.707ZM5 10a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1ZM8 16v-1h4v1a2 2 0 1 1-4 0ZM12.001 14c.015-.34.207-.646.476-.859a4 4 0 1 0-4.954 0c.27.213.462.519.476.859h4.002Z"
}));
export default LightBulbIcon;